import React, { useState } from "react";

const forms = [
  {
    id: "1",
    name: "Formulario no Bubble",
    type: "BUBBLE",
    config: {
      url: "https://evarella.bubbleapps.io/",
    },
  },
  {
    id: "2",
    name: "Formulario no Google Forms",
    type: "GOOGLE",
    config: {
      url: "https://docs.google.com/forms/d/e/1FAIpQLSejpsoCZo_qeQ0U6OxXH_0N3Gc1oSv0UsqZpQrh1s6NUFgC3w/viewform?embedded=true",
    },
  },
];

export default function FormList() {
  const [selectedForm, setSelectedForm] = useState();
  return (
    <>
      <h1>List da Formularios</h1>
      <ul>
        {forms.map((form) => (
          <li>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedForm(form)}
            >
              {form.name}
            </a>{" "}
            ({form.type})
          </li>
        ))}
      </ul>
      <hr />
      {selectedForm && (
        <iframe src={selectedForm.config.url} width={"100%"} height={"600px"} />
      )}
    </>
  );
}
